import React, { useEffect, useState } from "react";
import AppNavbar from "../../Navbar/AppNavbar";
import Footer from "../../Navbar/Footer";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Skeleton } from "@mui/material";
import { SearchBtn } from "../../Buttons/Buttons";
import AddUserModal from "./AddUserModal";
import { useDispatch, useSelector } from "react-redux";
import { loadUsersData } from "../../redux/action";
import noDataImg from '../../../assets/images/No data-found.svg'
const Users = () => {

    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const sbnID = signInDetails[0]?.sbn_id;
    const signinID = signInDetails[0]?.id;
    const { usersData } = useSelector((state) => state.data);
    const { getCredits } = useSelector(state => state.data);

    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");

    const handleAddUserClick = () => {
        setOpenModal(true);  // Open the modal when "Add Users" is clicked
    };

    const handleCloseModal = () => {
        setOpenModal(false);  // Close the modal
        setUsername("");
        setEmail("");
        setPhone("");
    };

    const fetchUsersData = () => {
        dispatch(loadUsersData(sbnID, 'user', setLoading));
    }

    useEffect(() => {
        fetchUsersData();
    }, [])

    console.log(getCredits, "getCredits")
    console.log(usersData, "usersData")

    const [isAddEnable, setIsEnable] = useState(true)
    useEffect(() => {
        if (getCredits.current_plan === "basic" && usersData.length >= 2) {
            setIsEnable(false)
        } else if (getCredits.current_plan === "elite" && usersData.length >= 5) {
            setIsEnable(false)
        }
    }, [getCredits, usersData])
    // getCredits.current_plan 

    return (
        <div className="page-layout">
            <AppNavbar />
            <div className="page-content">
                <div className="saved-search-container">
                    <div className="saved-search-header-container">
                        <div className="saved-search-header-div">
                            <p>List</p>
                            <div className="saved-search-img-div">
                                <h5>Users</h5>
                                <i className="fa-regular fa-user"></i>
                            </div>
                        </div>
                        <div className="d-flex gap-2">
                            {isAddEnable && <SearchBtn btnName="Add Users" onClickEffect={handleAddUserClick} />}
                        </div>
                    </div>
                    <TableContainer component={Paper} className="flagged-contact-table">
                        <Table aria-label="user table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ minWidth: "80px" }}>Sl.no</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Username</TableCell>
                                    <TableCell style={{ minWidth: "200px" }}>Email</TableCell>
                                    <TableCell style={{ minWidth: "150px" }}>Contact</TableCell>
                                    <TableCell style={{ minWidth: "100px" }}>Action</TableCell>
                                    <TableCell style={{ minWidth: "150px" }}>Upload Access</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    [...Array(5)].map((_, index) => (
                                        <TableRow key={index}>
                                            <TableCell><Skeleton height={40} /></TableCell>
                                            <TableCell><Skeleton height={40} /></TableCell>
                                            <TableCell><Skeleton height={40} /></TableCell>
                                            <TableCell><Skeleton height={40} /></TableCell>
                                            <TableCell><Skeleton height={40} /></TableCell>
                                            <TableCell><Skeleton height={40} /></TableCell>
                                        </TableRow>
                                    ))
                                ) : usersData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            <div className="no-data-container">
                                                <img src={noDataImg} alt="No Data Found" className="no-data-img" style={{ height: "250px", width: "280px" }} />
                                                <p>No users found</p>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    usersData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell>{row.email}</TableCell>
                                            <TableCell>{row.phone}</TableCell>
                                            <TableCell>
                                                <div className={`status-badge ${row.status === 1 ? 'complete-status' : 'cancel-status'}`}>
                                                    {row.status === 1 ? "Active" : "In-acive"}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className={`status-badge ${row.upload === true ? 'complete-status' : 'cancel-status'}`}>
                                                    {row.upload === true ? "Enable" : "Disable"}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

            {/* Modal for adding users */}
            <AddUserModal
                show={openModal}
                handleClose={handleCloseModal}
                signinID={signinID}
                sbnID={sbnID}
                fetchUsersData={fetchUsersData}
                username={username}
                email={email}
                phone={phone}
                setUsername={setUsername}
                setEmail={setEmail}
                setPhone={setPhone}
            />
            <Footer />
        </div>
    );
};

export default Users;
